import {
  IExternalProviderResponse,
  LinkGoogleExternalProviderRequest,
} from '../../api-client/autogenerated';
import { ApiClient } from '../../api-client/api-client';

export const getMyExternalProviders = async (): Promise<IExternalProviderResponse[]> => {
  return ApiClient.getMyExternalProviders().then((res) => res.data);
};

export const linkGoogleExternalProvider = async (
  params: LinkGoogleExternalProviderRequest,
): Promise<IExternalProviderResponse> => {
  return ApiClient.linkGoogleExternalProvider({
    linkGoogleExternalProviderRequest: params,
  }).then((res) => res.data);
};

export const unlinkGoogleExternalProvider = async (): Promise<void> => {
  return ApiClient.unlinkProvider({ provider: 'google' }).then(() => undefined);
};
